import { ExportButton } from "@/molecules/ExportButton"
import type { DatePickerExportContainerProps } from "."
import { Filter } from "../FilterNew/Filter"
import styles from "./DatePickerExportContainer.module.scss"

export const DatePickerExportContainer = ({
  exportType,
  placement,
  isLoading,
  disableExport,
  pickerType = "datePicker"
}: DatePickerExportContainerProps) => (
  <div className={styles.container}>
    {pickerType === "rangePicker" ? (
      <Filter.RangePicker isLoading={isLoading} placement={placement} />
    ) : (
      <Filter.DatePicker
        type="timestamp"
        isLoading={isLoading}
        placement={placement}
      />
    )}
    <ExportButton
      isLoading={disableExport || isLoading}
      exportType={exportType}
    />
  </div>
)
